/**
 * Hero-scoped backdrop: subtle dot-grid + dual radial glows. Sits behind
 * the headline at -z-10 and stops short of the section break so the
 * comparison panel below reads on flat #121212.
 *
 * Implementation notes:
 * - Grid is a single `radial-gradient(circle at center, ...)` repeated via
 *   `background-size`, not 1000 div elements. Cheap to render.
 * - Glows fade to transparent via `mask-image` so they don't hard-edge.
 * - Decorative only — `aria-hidden`, never tabbable.
 */
export function BackgroundAtmosphere() {
  return (
    <div aria-hidden className="pointer-events-none absolute inset-0 -z-10 overflow-hidden">
      {/* Dot grid — 32px lattice, very low opacity, masked off at the edges */}
      <div
        className="absolute inset-0 opacity-[0.18]"
        style={{
          backgroundImage:
            'radial-gradient(circle at center, rgba(245,245,245,0.7) 1px, transparent 1.5px)',
          backgroundSize: '32px 32px',
          maskImage:
            'radial-gradient(ellipse 80% 60% at 50% 30%, #000 30%, transparent 80%)',
          WebkitMaskImage:
            'radial-gradient(ellipse 80% 60% at 50% 30%, #000 30%, transparent 80%)',
        }}
      />

      {/* Primary blue wash — top-left */}
      <div
        className="absolute -top-32 -left-40 h-[560px] w-[560px] rounded-full opacity-30 blur-3xl"
        style={{ backgroundColor: 'var(--color-primary)' }}
      />

      {/* Secondary magenta wash — bottom-right of the hero region */}
      <div
        className="absolute top-40 -right-32 h-[480px] w-[480px] rounded-full opacity-25 blur-3xl"
        style={{ backgroundColor: 'var(--color-secondary)' }}
      />

      {/* Top vignette to soften the sticky nav merge */}
      <div className="absolute inset-x-0 top-0 h-32 bg-gradient-to-b from-bg to-transparent" />
    </div>
  )
}
